<section class="section-gap innerPageBg">
    <button mat-icon-button color="primary" class="closeDialogBtn" (click)="closeDialog()"><mat-icon>close</mat-icon></button>
    <div class="container">
      <app-global-breadcrumbs></app-global-breadcrumbs>
        <div class="row align-items-center justify-content-between d-flex noHeightSet">
            <div class="col-md-5 imageSide">
                <h2 class="titleSection">Lowest Airfare Guarantee</h2>
                <div class="imgWraper">
                    <img src="../../../assets/belairtrip_assets/svg_icon/bt-hotel-vector.svg" alt="" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6 col-md-12 p-0">
                <div class="wrapper">
                    <mat-card class="cardSection">
                        <div *ngIf="selectedTab === 'Login'"  class="titleSection">
                            <p>Welcome Back,</p>
                            <h4>Your Next Flight Deal is Just a Few Clicks Away</h4>
                        </div>
                        <div *ngIf="selectedTab === 'Register'" class="titleSection">
                            <p>Welcome to Belairtrip,</p>
                            <h4>Sign Up for Easy Access to the Best Flight Deals</h4>
                        </div>
                        <mat-tab-group (selectedTabChange)="onTabChange($event)" #tabGroup dynamicHeight color="primary">
                            <mat-tab label="Login">
                                <app-login [successMessage]="successMsg"></app-login>
                            </mat-tab>
                            <mat-tab label="Register">
                                <app-signup (signUpSuccess)="switchToLogin($event)"></app-signup>
                            </mat-tab>
                        </mat-tab-group>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>
</section>
